import React from 'react';
import irelandApi from '../irelandApi';
import { toast } from 'react-toastify';
import store, { history } from '../store';
import ToastMessage from '../components/common/toast-message';

const ACCOUNT_MANAGERS_URL = '/api/admin/account_managers';

export const validateRegistrationAccountManager = payload => {
  return irelandApi
    .post('/api/users/account_manager_validation', { account_manager: payload })
    .then(function(response) {
      const { registration_token, user_group, email } = response.data;

      store.dispatch({
        type: 'ACCOUNT_MANAGER_VALIDATION_FULLFILLED',
      });
      store.dispatch({
        type: 'SET_REGISTRATION_TOKEN',
        payLoad: {
          registration_token,
          user_group,
          email
        }
      });
      history.push('/registration/about-you');  
    })
    .catch(function(error) {
      return Promise.reject(error.response.data.errors.account_manager);
    });
};

export const getAdminAccountManagers = (ho_account_id = '', filter = '', page = '') => dispatch => {
  dispatch({
    type: 'GET_ACCOUNT_MANAGERS_PENDING',
    payload: []
  });
  return irelandApi
    .get(ACCOUNT_MANAGERS_URL, { params: { q: filter, page: page, ho_account_number_id: ho_account_id } })
    .then(response => {
      dispatch({
        type: 'GET_ADMIN_ACCOUNT_MANAGERS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch(error => {
      dispatch({
        type: 'GET_ACCOUNT_MANAGERS_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const addAccountManager = () => (dispatch) => {
  dispatch({ type: 'ADD_ACCOUNT_MANAGER_PENDING' });
  return irelandApi.get(`${ACCOUNT_MANAGERS_URL}/new`)
    .then((response) => {
      dispatch({
        type: 'ADD_ACCOUNT_MANAGER_FETCHED',
        payLoad: response.data
      })
    })
    .catch((error) => {
      dispatch({
        type: 'ADD_ACCOUNT_MANAGER_REJECTED',
        payLoad: error.response
      })
    });
};

export const getAccountManager = (id) => (dispatch) => {
  dispatch({type: 'GET_ACCOUNT_MANAGER_PENDING'});
  return irelandApi.get(`${ACCOUNT_MANAGERS_URL}/${id}`)
    .then((response) => {
      dispatch({
        type: 'GET_ACCOUNT_MANAGER_FETCHED',
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_ACCOUNT_MANAGER_REJECTED',
        payLoad: error.response
      })
    })
};

export const saveAccountManager = (hoAccountId, payLoad, _) => {
  let data = {
    ho_account_number_id: hoAccountId,
    ...payLoad
  };

  return irelandApi.post(ACCOUNT_MANAGERS_URL, { account_manager: data })
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Account manager has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving Account Manager"/>);

      const errorData = error.hasOwnProperty('response') ? error.response.data.errors : [];

      return Promise.reject(errorData);
    })
};

export const updateAccountManager = (id, payLoad, _) => {
  return irelandApi.patch(`${ACCOUNT_MANAGERS_URL}/${id}`, { account_manager: payLoad })
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Account manager has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Error while saving Account Manager"/>);

      const errorData = error.hasOwnProperty('response') ? error.response.data.errors : [];

      return Promise.reject(errorData);
    }).then(() => {
      history.push('/admin/ho-accounts');
    });
};



// WEBPACK FOOTER //
// ./src/actions/account-managers.js